import { GameActions } from "State/Game/GameActions";
import { AvoTracking } from "Utility/Tracking/Avo/AvoTracking";

export default class CheatsManager {

    // static

    private static firstInstance: CheatsManager | null = null;

    public static getFirstInstance(): CheatsManager | null {
        return this.firstInstance;
    }

    // instance

    public cheatsEnabled: boolean = false;

    private enableCheatsFunc: null | (() => void);

    private ignoreCardMatchRules: boolean = false;

    constructor(params: {
        autoEnableCheats: boolean,
        enableCheatsFunc: () => void,
    }) {
        if (CheatsManager.firstInstance === null) {
            CheatsManager.firstInstance = this;
        }

        this.enableCheatsFunc = params.enableCheatsFunc;
        if (params.autoEnableCheats) {
            this.enableCheats();
            
        } else {
            this.addKonamiInputListener();
        }
    }

    private enableCheats() {
        if (this.cheatsEnabled) return;

        // Allow level files to be loaded by dropping them.
        this.setupDropListener();

        this.enableMatchAnyCardCheat();

        this.cheatsEnabled = true;

        const enableCheats = this.enableCheatsFunc;
        this.enableCheatsFunc = null;
        enableCheats();
    }

    private addKonamiInputListener() {

        if (this.cheatsEnabled) return;

        const konami: string = '38384040373937396665';

        let input = '';

        const onKeyUp = (event: KeyboardEvent) => {
            if (this.cheatsEnabled) {
                removeListener();
                return;
            }
            input += event.keyCode;
            if (input !== konami.substr(0, input.length)) {
                input = '';
            } else if (input === konami) {
                console.log('\n' + [
                    '**********************************************************************',
                    '*************************** CHEATS ENABLED ***************************',
                    '**********************************************************************',
                ].join('\n'));
                removeListener();
                this.enableCheats();

                // Track that cheats were enabled.
                // AvoTracking.cheatsEnabled();
            }
        };

        addListener();

        return removeListener;

        function addListener() {
            window.addEventListener('keyup', onKeyUp);
        }

        function removeListener() {
            window.removeEventListener('keyup', onKeyUp);
        }
    }

    public shouldIgnoreCardMatchRules() {
        return this.ignoreCardMatchRules;
    }

    private enableMatchAnyCardCheat() {
        const updateIgnoreCardMatchRules = (e: KeyboardEvent) => {
            this.ignoreCardMatchRules = e.shiftKey;
        };
        window.addEventListener('keydown', updateIgnoreCardMatchRules);
        window.addEventListener('keyup', updateIgnoreCardMatchRules);
    }

    private setupDropListener() {
        if (!document) {
            console.error(`Could not add drop listener. Document is undefined.`);
            return;
        }
    
        const canvas = document.getElementsByTagName('canvas')[0];
        canvas.addEventListener('dragover', event => event.preventDefault());
        canvas.addEventListener('drop', async event => {
            event.preventDefault();
    
            for (let i = 0; i < event.dataTransfer.files.length; i++) {
                const file = event.dataTransfer.files[i];
                try {
                    const levelData = JSON.parse(await file.text());
                    GameActions.loadLevelDebug(levelData);
                    return;
                } catch (e) {
                    console.error(`Could not load level from file: ${file.name}.`, e);
                }
            }
        });
    }
}
